module.exports = __webpack_public_path__ + "yz/img/邮政.cdc2f06f.jpg";